<div class="main-view" style="display: flex; flex-direction: column; height: 100%;">
  <app-main-menu title="Fotos"></app-main-menu>

  <div style="flex:1; height: calc(100vh - 60px)">
    <app-photo-browser mode="edit"></app-photo-browser>
  </div>
</div>
